import { gql } from 'apollo-boost';

import { recommendationKeyFragment } from '../../queries/grid/recommendations';

export const executeRecommendationMutationInstance = gql`
    mutation executeRecommendationMutation(
        $input: GdExecuteRecommedationsInput!
    ) {
        reqId: getReqId
        executeRecommendation(input: $input) {
            items {
                ...recommendationKeyFragment
            }
        }
    }

    ${recommendationKeyFragment}
`;
